// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Y1Hm","content":"styles_content__2Gfmx","checkbox":"styles_checkbox__1evfO","checkboxLabel":"styles_checkboxLabel__2y3Z5"};